<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">Szűrők beállítása</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'search_modal', Anvil.page.search ],
				fields: [
					{
						type: 'text',
						name: 'expression',
						title: 'Szöveges keresés',
						attributes: {
							placeholder: 'Keresés...'
						},
						append: '<span class="input-group-text"><i class="fa fa-fw fa-search"></i></span>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'closed',
						title: 'Státusz',
						params: {
							maxItems: 1,
							options: [
								{ value: 0, label: 'Nyitott', icon: 'lock-open', color: 'text-warning' },
								{ value: 1, label: 'Lezárt', icon: 'lock', color: 'text-success' }
							],
							valueField: 'value',
							labelField: 'label',
							render: {
								item: (item, esc) => `<div><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`,
								option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`
							},
							placeholder: '[ minden státusz ]'
						},
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.closed = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'responsible_user_id',
						title: 'Felelős',
						params: {
							maxItems: 1,
							options: [ { id: -1, account_name: '[ felelős felhasználó nélkül ]' }, ...Anvil.page.users.data.filter(u => u.active) ],
							valueField: 'id',
							labelField: 'account_name',
							searchField: [ 'account_name' ],
							render: {
								item: (item, esc) => `<div><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`,
								option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`
							},
							placeholder: '[ minden felhasználó ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.responsible_user_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'worker_user_id',
						title: 'Résztvevő',
						params: {
							maxItems: 1,
							options: [ { id: -1, account_name: '[ résztvevő nélkül ]' }, ...Anvil.page.users.data.filter(u => u.active) ],
							valueField: 'id',
							labelField: 'account_name',
							searchField: [ 'account_name' ],
							render: {
								item: (item, esc) => `<div><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`,
								option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`
							},
							placeholder: '[ minden felhasználó ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.worker_user_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'work_tag_id',
						title: 'Jelleg',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ jelleg nélkül ]' }, ...Anvil.page.issue_tags.data.filter(t => t.type == 'work') ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div title="${esc(item.name)}"><i class="${item.icon} fa-fw fa-sm me-2" style="color:${item.color};"></i>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option"><i class="${item.icon ? item.icon : 'fa fa-sm fa-circle'} fa-fw fa-sm me-2" style="color:${item.color};"></i>${esc(item.name)}</div>`
							},
							placeholder: '[ minden jelleg ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.work_tag_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
				]
			}) %>
		</div>
	</div>
</div>
